import { BrowserRouter, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AnalyticsRouteTracking } from "./lib/analytics";
import ProtestAnnouncement from "./components/feature/ProtestAnnouncement";
import CookieBanner from "./pages/home/components/CookieBanner";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      let attempts = 0;
      const scrollToAnchor = () => {
        const target = document.getElementById(hash.slice(1));
        if (target) {
          target.scrollIntoView({ block: "start" });
          return;
        }
        if (attempts++ < 10) window.setTimeout(scrollToAnchor, 50);
      };
      window.setTimeout(scrollToAnchor, 0);
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AnalyticsRouteTracking />
        <InternalPageAnnouncement />
        <AppRoutes />
        <CookieBanner />
      </BrowserRouter>
    </I18nextProvider>
  );
}

// The newsroom homepage owns its masthead and ticker. Keep the existing global
// announcement and spacing on every internal route without redesigning them.
function InternalPageAnnouncement() {
  const { pathname } = useLocation();
  if (pathname === "/") return null;
  return <>
    <ProtestAnnouncement />
    <div className="h-64 sm:h-36 md:h-40" aria-hidden="true" />
  </>;
}

export default App;